import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import Training from './pages/Training';
import Progress from './pages/Progress';
import Exercises from './pages/Exercises';
import ExerciseForm from './pages/ExerciseForm';
import TrainingDays from './pages/TrainingDays';
import TrainingDayForm from './pages/TrainingDayForm';
import RoutineStatus from './pages/RoutineStatus';
import RoutineForm from './pages/RoutineForm';
import WorkoutSession from './pages/WorkoutSession';
import WorkoutSummary from './pages/WorkoutSummary';
import ImportRoutine from './pages/ImportRoutine';
import ErrorBoundary from './components/ErrorBoundary';
import DatabaseErrorBoundary from './components/DatabaseErrorBoundary';
import WorkoutErrorBoundary from './components/WorkoutErrorBoundary';


const AppContent: React.FC = () => {
  const navigate = useNavigate();

  const handleImportFromClipboard = async () => {
    try {
      // Read clipboard (this will trigger permission request)
      const clipboardText = await navigator.clipboard.readText();
      
      // Check if it's a routine import URL
      if (clipboardText && 
          clipboardText.includes('/import-routine') && 
          clipboardText.includes('data=')) {
        
        // Extract the import route and navigate to it
        const url = new URL(clipboardText);
        const pathname = url.pathname;
        const search = url.search;
        navigate(pathname + search);
      } else {
        alert('No workout routine found in clipboard.\n\nPlease copy a routine sharing link first, then try importing again.');
      }
    } catch (error) {
      if (error instanceof Error && error.name === 'NotAllowedError') {
        alert('Clipboard access denied.\n\nPlease allow clipboard access to import shared routines.');
      } else {
        alert('Failed to read clipboard. Please try again.');
      }
    }
  };

  // Make this function available globally for other components to use
  (window as any).importFromClipboard = handleImportFromClipboard;

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Training />} />
          <Route path="routines" element={<Training />} />
          <Route path="progress" element={<Progress />} />
          <Route path="exercises" element={<Exercises />} />
          <Route path="exercises/:id" element={<ExerciseForm />} />
          <Route path="training-days" element={<TrainingDays />} />
          <Route path="training-days/:id" element={<TrainingDayForm />} />
          <Route path="routines/new" element={<RoutineForm />} />
          <Route path="routines/:id" element={<RoutineStatus />} />
          <Route path="routines/:id/edit" element={<RoutineForm />} />
          <Route path="workout/:sessionId" element={
            <WorkoutErrorBoundary>
              <WorkoutSession />
            </WorkoutErrorBoundary>
          } />
          <Route path="workout-edit/:sessionId/:exerciseIndex" element={
            <WorkoutErrorBoundary>
              <WorkoutSession />
            </WorkoutErrorBoundary>
          } />
          <Route path="summary/:sessionId" element={<WorkoutSummary />} />
          <Route path="import-routine" element={<ImportRoutine />} />
        </Route>
      </Routes>
    </>
  );
};

function App() {
  return (
    <ErrorBoundary context="application root">
      <DatabaseErrorBoundary>
        <Router>
          <AppContent />
        </Router>
      </DatabaseErrorBoundary>
    </ErrorBoundary>
  );
}

export default App;
